// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2IVGm","unreadBadge":"styles_unreadBadge__1PyDU","modalContent":"styles_modalContent__1vCdD","modal":"styles_modal__3daSO"};